import { optimizeImageForUpload } from './image'

export default async function upload (self, uploadPhotos, selectSchoolId, selectYearId, selectEventId, eventName) {
    return new Promise(async (resolve, reject) => {
        const regexp = /[^a-zA-Z0-9!@#$%^&*()_+\-=,.<>?;:'"[\]{}|\\/~`]+/u

        for (let i = 0; i < uploadPhotos.length; i++) {
            const photo = uploadPhotos[i]
            if (photo.name.match(regexp)) {
                self.$root.$emit('notification', 'is-danger', `写真名には半角英数字、記号以外を利用できません`)
                return
            }
        }

        const sleep = (time) => new Promise((resolve) => setTimeout(resolve, time))

        let uploadCount = 0
        let errorCount = 0

        const failedPhotoNames = []

        for (let i = 0; i < uploadPhotos.length; i++) {
            const photo = uploadPhotos[i]
            let uploadPhoto = photo

            try {
                uploadPhoto = await optimizeImageForUpload(photo)
            } catch (e) {
                // ブラウザで変換できない形式は、サーバー側の補正処理へ委ねる。
                console.warn(`画像の事前最適化をスキップしました: ${photo.name}`, e)
            }

            let formData = new FormData()
            formData.append('photo', uploadPhoto, photo.name)
            formData.append('school_id', selectSchoolId)
            formData.append('year_id', selectYearId)
            formData.append('event_id', selectEventId)

            let err = false

            await self.axios.post(`${process.env.UPLOAD_API_URL}/photographer/photo`, formData, {
                withCredentials: true,
                onUploadProgress (e) {
                    console.log(e)
                }
            }).catch((e) => {
                err = true
                // self.$root.$emit('notification', 'is-danger', `${photo.name} のアップロードに失敗しました`)
            })

            if (err) {
                errorCount++
                await sleep(5000)
                if (errorCount < 3) {
                    --i
                    continue
                }
            }

            errorCount = 0

            if (err) {
                failedPhotoNames.push(photo.name)
            } else {
                uploadCount++
                self.$root.$emit('notification', 'is-primary', `${uploadCount}/${uploadPhotos.length} 件アップロード完了`)
            }
            if (uploadPhotos.length === (uploadCount + failedPhotoNames.length)) {
                console.log(`${selectSchoolId}-${selectYearId}-${selectEventId}`)
                sessionStorage.setItem(`${selectSchoolId}-${selectYearId}-${selectEventId}`, JSON.stringify(failedPhotoNames))
                self.$root.$emit('notification', 'is-primary', `${uploadCount}/${uploadPhotos.length} ${eventName} のアップロードが完了しました（エラー${failedPhotoNames.length}件)`)
                resolve(failedPhotoNames.length)
            }
        }
    })
}



// WEBPACK FOOTER //
// ./src/helpers/upload.js